import { render, staticRenderFns } from "./TsWelcomeToItaly.vue?vue&type=template&id=473d3e84&scoped=true"
import script from "./TsWelcomeToItaly.vue?vue&type=script&lang=js"
export * from "./TsWelcomeToItaly.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "473d3e84",
  null
  
)

export default component.exports